import React from "react";
import BookingContent from "../content/bookingContent";
import Layout from "../layout/Layout";

const Booking = () => {
  return (
    <Layout>
      <BookingContent />
    </Layout>
  );
};

export default Booking;
